import React from "react";
import { connect } from "react-redux";
import { Button, ValidationGroup } from "devextreme-react";
import { lastStep, nextStep, setDataNewComplain, setCiudadesComunasSiniestro } from "../../actions";
import TextField from "../../../../../../Shared/fields/TextField";
import RadioGroupfield from "../../../../../../Shared/fields/RadioGroupField";
import SelectField from "../../../../../../Shared/fields/SelectField";
import DirectionFields from "../fields/DirectionsFields";
import DateField from "../../../../../../Shared/fields/DateField";
import { getCiudadesComunas } from "../../../../../../../helpers/direccionesNuevaDenunciaFormat";
import validaciones from "../../../../../../../helpers/validaciones";

class DatoSiniestro extends React.PureComponent {
  constructor(props) {
    super(props);

    if (!props.jsonData.formDatoSiniestro.FechaHoraAccidente) {
      props.jsonData.formDatoSiniestro.FechaHoraAccidente = props.jsonData.formInfoDenuncia.FechaPresentacion;
    }
  }
  handleBack = () => {
    this.props.dispatch(lastStep());
  }
  handleNext = (params) => {
    const result = params.validationGroup.validate();
    if (result.isValid) {
      this.props.dispatch(nextStep());
    }
  }

  handleChange = (e) => {
    const jsonData = { ...this.props.jsonData };

    switch (e.element.id) {
      case "Region": {
        const result = getCiudadesComunas(this.props.listaDirecciones, e.value.IdRegion);
        this.props.dispatch(setCiudadesComunasSiniestro(result.listaCiudades, result.listaComunas.sort(validaciones.sortComunas)));
        jsonData.formDatoSiniestro.Comuna = null;
        jsonData.formDatoSiniestro.Ciudad = null;
        jsonData.formDatoSiniestro[e.element.id] = e.value;

        break;
      }
      case "FechaHoraAccidente": {
        jsonData.formDatoSiniestro.modHora = true;
        const date = new Date(jsonData.formDatoSiniestro.FechaHoraAccidente);
        const hours = new Date(e.value);
        date.setHours(hours.getHours(), hours.getMinutes(), hours.getSeconds());
        jsonData.formDatoSiniestro.FechaHoraAccidente = date;
        break
      }
      default:
        jsonData.formDatoSiniestro[e.element.id] = e.value;
        break;
    }

    this.props.dispatch(setDataNewComplain(jsonData));
  }

  render() {
    const form = this.props.jsonData.formDatoSiniestro;

    return (
      <ValidationGroup className="row">
        <div className="col-12 newDenuncia-title">
          <h2>Datos del accidente</h2>
          <p>Completa los datos para pasar a la siguiente sección</p>
        </div>
        <div className="col-12">
          <h4 className="newDenuncia-subtitle">Dirección del accidente</h4>
        </div>

        <div className="col-12">
          <DirectionFields
            onChange={this.handleChange}
            form={form}
            renderPhone={false}
          />
        </div>

        <div className="col-12">
          <h4 className="newDenuncia-subtitle">Antecedentes del accidente</h4>
        </div>

        <div className="col-12">

          <SelectField
            label="Tipo de accidente"
            id="TipoAccidente"
            required
            value={form.TipoAccidente}
            onValueChanged={this.handleChange}
            items={this.props.listaTiposAccidente}
            acceptCustomValue
            displayExpr="DescripcionTipoAccidente"
          />

          {form.TipoAccidente && form.TipoAccidente.IdTipoAccidente === 2 &&
            <SelectField
              label="Tipo de accidente de trayecto"
              optional
              required
              id="TipoAccidenteTrayecto"
              value={form.TipoAccidenteTrayecto}
              onValueChanged={this.handleChange}
              acceptCustomValue
              items={this.props.listaTiposAccidenteTrayecto}
              displayExpr="DescripcionTipoAccidenteTrayecto"
            />
          }

          {/* <RadioGroupfield
            label="En condiciones ligeramente diferentes ¿Usted cree que este accidente pudo haber sido más grave o fatal?"
            placeholder="Ejemplo: Haber quedado con una secuela permanente o haber causado la muerte"
            items={[{ text: "Si", value: "X" }, { text: "No", value: "N" }]}
            required
            layout="horizontal"
            displayExpr="text"
            valueExpr="value"
            id="CondicionesAccidente"
            onValueChanged={this.handleChange}
            value={form.CondicionesAccidente}
          /> */}

          {/* {form.CondicionesAccidente === "X" &&  */}
          <SelectField
            label="Clasificación del accidente (grado)"
            id="ClasificacionAccidente"
            required
            value={form.ClasificacionAccidente}
            onValueChanged={this.handleChange}
            acceptCustomValue
            dataSource={this.props.listaClasificacionesAccidentes}
            displayExpr="ClasificacionAccidente"
          />
          {/* } */}

          <div className="row">
            <div className="col-6">
              <DateField
                label="Fecha del accidente"
                required
                disabled
                value={form.FechaHoraAccidente}
                onValueChanged={this.handleChange}
                type="date"
              />
            </div>
            <div className="col-6">
              <DateField
                id="FechaHoraAccidente"
                label="Hora del accidente"
                required
                value={form.modHora ? form.FechaHoraAccidente : null}
                onChange={this.handleChange}
                type="time"
              />
            </div>
          </div>


          <TextField
            id="SitioAccidente"
            required
            maxLength={200}
            label="Sitio preciso del accidente"
            value={form.SitioAccidente}
            useInputChange
            onValueChanged={this.handleChange}
          />

          <TextField
            id="TrabajoHabitual"
            required
            maxLength={100}
            useInputChange
            label="Trabajo habitual del trabajador"
            value={form.TrabajoHabitual}
            onValueChanged={this.handleChange}
          />

          <TextField
            id="ActividadAntesAccidente"
            required
            maxLength={200}
            useInputChange
            label="Actividad realizada antes del accidente"
            value={form.ActividadAntesAccidente}
            onValueChanged={this.handleChange}
          />

          <RadioGroupfield
            label="¿Al momento del accidente realizaba su trabajo habitual?"
            required
            items={[{ text: "Si", value: "X" }, { text: "No", value: "N" }]}
            layout="horizontal"
            id="RealizabaSuTrabajo"
            onValueChanged={this.handleChange}
            value={form.RealizabaSuTrabajo}
            displayExpr="text"
            valueExpr="value"
          />

          <TextField
            id="AlMomentoDelAccidente"
            required
            maxLength={200}
            useInputChange
            label="Al momento del accidente el trabajador se encontraba"
            placeholder="Ejemplo: bajando ropa – cortando una tubería, etc."
            value={form.AlMomentoDelAccidente}
            onValueChanged={this.handleChange}
          />

          <TextField
            id="CausaAccidente"
            required
            maxLength={100}
            useInputChange
            label="Lo que ocurrió fue que (causa del accidente)"
            placeholder="Ejemplos: sufre caída - se resbala del tubo"
            value={form.CausaAccidente}
            onValueChanged={this.handleChange}
          />

          <TextField
            id="Agente"
            required
            maxLength={100}
            useInputChange
            label="Se accidentó (agente)"
            placeholder="Ejemplos: con peldaño de escala – con sierra manual"
            value={form.Agente}
            onValueChanged={this.handleChange}
          />

          <TextField
            id="Consecuencia"
            required
            useInputChange
            maxLength={100}
            label="La lesión que presenta es (consecuencia)"
            placeholder="Ejemplo: contusión y dolor – herida cortante"
            value={form.Consecuencia}
            onValueChanged={this.handleChange}
          />

          <TextField
            id="ZonaAfectada"
            required
            maxLength={100}
            useInputChange
            label="La zona afectada es (indique lateralidad cuando corresponda)"
            placeholder="Ejemplos: pierna derecha – dedo anular izquierdo"
            value={form.ZonaAfectada}
            onValueChanged={this.handleChange}
          />

          <RadioGroupfield
            label="¿Tiene testigos presenciales de su accidente?"
            items={[{ text: "Tiene testigos de su accidente", value: "X" }, { text: "No tiene testigos de su accidente", value: "N" }]}
            layout="vertical"
            id="Testigos"
            required
            displayExpr="text"
            valueExpr="value"
            onValueChanged={this.handleChange}
            value={form.Testigos}
          />

          {form.Testigos && form.Testigos === "X" &&
            <TextField
              id="DatosTestigo"
              required
              maxLength={100}
              useInputChange
              optional
              label="El nombre y cargo del testigo es"
              placeholder="Ejemplos:  Juán Pérez, compañero de trabajo - Rodrigo Díaz, Jardinero - Carmen Zapata, Secretaria"
              value={form.DatosTestigo}
              onValueChanged={this.handleChange}
            />
          }

          <RadioGroupfield
            label="¿Avisó a la empresa sobre el accidente?"
            required
            items={[{ text: "Si", value: "X" }, { text: "No", value: "N" }]}
            layout="horizontal"
            displayExpr="text"
            valueExpr="value"
            id="Aviso"
            value={form.Aviso}
            onValueChanged={this.handleChange}
          />

          {form.Aviso === "X" && (
            <React.Fragment>

              <TextField
                id="NombreCargoPersonaAviso"
                required={form.Aviso === "X"}
                maxLength={100}
                useInputChange
                label="¿Nombre y cargo de la persona a la que dio aviso del accidente?"
                placeholder="Ejemplos: Carolina Espinoza, Prevencionista - Magdalena Torres, Jefe de Producción - Jorge Díaz, Capataz"
                value={form.NombreCargoPersonaAviso}
                onValueChanged={this.handleChange}
              />


              <DateField
                label="Fecha y hora en que avisó a su empresa sobre el accidente"
                id="FechaHoraAviso"
                required={form.Aviso === "X"}
                value={form.FechaHoraAviso}
                onValueChanged={this.handleChange}
                type="datetime"
              />

            </React.Fragment>
          )
          }

          {form.TipoAccidente && form.TipoAccidente.IdTipoAccidente === 2 && (
            <React.Fragment>
              <SelectField
                label="Medio de prueba"
                id="MedioPrueba"
                required
                value={form.MedioPrueba}
                onValueChanged={this.handleChange}
                dataSource={this.props.listaMediosPrueba}
                displayExpr="MedioPrueba"
                acceptCustomValue
              />

              <TextField
                id="DetalleMedioPrueba"
                maxLength={200}
                required
                useInputChange
                label="Detalle del medio de prueba"
                value={form.DetalleMedioPrueba}
                onValueChanged={this.handleChange}
              />
            </React.Fragment>
          )}

        </div>

        <div className="col-12">
          <Button text="Volver" className="newDenuncia-back-button" onClick={this.handleBack} />
          <Button
            text="Siguiente"
            type="success"
            className="newDenuncia-next-button"
            onClick={this.handleNext}
            useSubmitBehavior
          />
        </div>
      </ValidationGroup>
    );
  }
}
const mapStateToProps = (state) => ({
  jsonData: state.denuncias.jsonData,
  listaMediosPrueba: state.global.listaMediosPrueba,
  listaDirecciones: state.global.listaDirecciones,
  listaClasificacionesAccidentes: state.global.listaClasificacionesAccidentes,
  listaTiposAccidente: state.global.listaTiposAccidente,
  listaTiposAccidenteTrayecto: state.global.listaTiposAccidenteTrayecto,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(DatoSiniestro);
